module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-19.557ddd28.svg";